import _ from 'lodash';

/**
 * query = [gql query, variables = {}]
 * variables = variables used for that query
 * path = path to the value we're updating in the cache
 * updater = function that updates that value (`({ value, mutationData, mutationVariables }) => newValue)
 */
export const apolloCacheUpdate = ({ query, variables, path, updater }) => (
  cache,
  { data: mutationData },
  { variables: mutationVariables },
) => {
  try {
    const cacheData = cache.readQuery({
      query,
      variables,
    });

    const value = _.get(cacheData, path);
    const newValue = updater(value, { mutationData, mutationVariables });

    // update without mutation (by shallow cloning just the objects in the path)
    const data = _.setWith(_.clone(cacheData), path, newValue, _.clone);

    cache.writeQuery({
      query,
      data,
    });
  } catch (err) {
    console.error(err);
  }
};
